/* eslint-disable better-mutation/no-mutation */
import { createSlice } from '@reduxjs/toolkit';
import getInitialState from './initial-state';

const payoutsSlice = createSlice({
    name: 'payouts',
    initialState: getInitialState(),
    reducers: {
        setPayoutStatus: (state, { payload }) => {
            state.payoutStatus = payload;
        },
        setEntries: (state, { payload }) => {
            state.entries.list = payload;
        },
        setPagination: (state, { payload }) => {
            state.entries.pagination = payload;
        },
        setEntriesLoadingStatus: (state, { payload }) => {
            state.entries.loadingStatus = payload;
        },
        setEntriesLoadAction: (state, { payload }) => {
            state.entries.loadAction = payload;
        },
        resetEntries: (state) => {
            state.entries = getInitialState().entries;
        },
        setPending: (state, { payload }) => {
            state.pending = payload;
        },
        setCsvLoading: (state, { payload }) => {
            state.csvLoading = payload;
        },
        updatePayoutFrequency: (state, { payload }) => {
            state.payoutStatus.payoutFrequencyOption = payload;
        },
        setShowPayoutFrequencyModal: (state, { payload }) => {
            state.showPayoutFrequencyModal = payload;
        }
    }
});

export const {
    setPayoutStatus,
    setEntries,
    setPagination,
    setEntriesLoadingStatus,
    setEntriesLoadAction,
    resetEntries,
    setPending,
    setCsvLoading,
    updatePayoutFrequency,
    setShowPayoutFrequencyModal
} = payoutsSlice.actions;

export default payoutsSlice.reducer;
